<template>
  <div class="toggle-cell" :disabled="disabledStatus">
    <label :for="value" class="toggle-label">
      <input
        class="toggle-input toggle-input--hide-radio"
        type="radio"
        :id="value"
        :value="value"
        :checked="checkedStatus"
        :disabled="disabledStatus"
        @click="notify"
      />

      <div
        :class="toggleItemClass"
        @touchstart="addHoverEffect"
        @mouseenter="addHoverEffect"
        @mouseleave="removeHoverEffect"
        @touchmove="removeHoverEffect"
        @click="removeHoverEffect"
      >
        <i class="material-icons toggle-content-icon">{{ icon }}</i>
        <div class="toggle-content-text">
          {{ text }}
          <span
            class="index-choice-label"
            v-show="
              checkedStatus && indexChoice !== undefined && !isHideChoiceRanking
            "
          >
            {{ indexChoiceLabel }}
          </span>
        </div>
        <i :class="toggleIconClass">{{ toggleIcon }}</i>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    index: {
      type: Number
    },
    indexChoice: {
      type: Number
    },
    icon: {
      type: String
    },
    toggleIcon: {
      type: String
    },
    text: {
      type: String
    },
    checkedStatus: {
      type: Boolean
    },
    disabledStatus: {
      type: Boolean
    },
    toggleClass: {
      type: String
    },
    customOptions: {
      type: Object
    }
  },
  computed: {
    indexChoiceLabel() {
      if (this.indexChoice !== -1) {
        return `${this.ordinalSuffix(this.indexChoice + 1)} Choice`;
      }
      return '';
    },
    toggleIconClass() {
      return `material-icons ${this.toggleClass}`;
    },
    toggleItemClass() {
      return `toggle-content flex flex--row flex--center ${this.isHover}}`;
    },
    isHideChoiceRanking() {
      if (!this.customOptions) {
        return false;
      }
      return this.customOptions.hideChoiceRanking;
    }
  },
  methods: {
    // Notify the parent on input
    notify(e) {
      this.$emit('inputting', e.target.value, this.index);
    },
    addHoverEffect() {
      this.isHover = 'hover-effect';
    },
    removeHoverEffect() {
      this.isHover = '';
    },
    ordinalSuffix(i) {
      let j = i % 10,
        k = i % 100;
      if (j == 1 && k != 11) {
        return i + 'st';
      }
      if (j == 2 && k != 12) {
        return i + 'nd';
      }
      if (j == 3 && k != 13) {
        return i + 'rd';
      }
      return i + 'th';
    }
  },
  data() {
    return {
      isHover: ''
    };
  },
  mounted() {
    componentHandler.upgradeAllRegistered();
  }
};
</script>

<style scoped>
.low-opacity {
  opacity: 0.6;
}

/** Toggle List **/
.toggle-cell {
  border-bottom: 1px solid #ddd;
}

.toggle-content {
  padding: 10px 10px;
  margin: 0px 0px;
}

/** effect applied manually on mouse events
to prevent touch screen issues **/
.hover-effect {
  background-color: #dfdfdf;
}

.toggle-input--hide-radio {
  position: absolute;
  visibility: hidden;
}

.toggle-input + div {
  transition: background-color 0.2s ease-in-out;
}

.toggle-input:checked + div {
  background-color: rgba(63, 81, 181, 0.92);
  color: #f7f7f7;
}

.toggle-input:disabled + div {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: none;
  color: rgba(0, 0, 0, 0.12);
  pointer-events: none;
  border: none;
}

.toggle-input:checked + div > .toggle-content-action {
  display: inline;
}

.toggle-content-text {
  padding-left: 10px;
  flex: 0 1 90%;
}

.toggle-content-action {
  display: none;
}

.toggle-content-icon {
  font-size: 3rem;
  opacity: 0.87;
}

.index-choice-label {
  border: 0;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 13px;
  margin-left: 4px;
  padding: 4px 8px;
  white-space: nowrap;
}
</style>
